import React, { CSSProperties } from "react";

const DashboardLabel: React.FC<({
    required?: boolean,
    requiredColor?: string,
    requiredContent?: string,
    label: string,
    labelClassName?: string,
    labelStyle?: CSSProperties
})> = ({
    required = false,
    requiredColor = 'var(--red)',
    requiredContent = '*',
    label,
    labelClassName = '',
    labelStyle
}) => {
    return (
        <span className={`label-input ${labelClassName}`} style={labelStyle}>
            {required && <span style={{ color: requiredColor }}>{requiredContent}</span>}
            {label}
        </span>
    )
}

export default DashboardLabel;